import logo from '../assets/reilm-logo.svg'
import { Link, useNavigate } from 'react-router-dom'
import { ReactComponent as AvatarIcon } from  '../assets/avatar1.svg'

const AppNavbar = () => {

  const navigate = useNavigate();

  const toLanding = () => {
        navigate('/')
    }

  return (
    <header className="h-[96px] bg-brand-pageFill border-b border-black/5">
      <div className="h-full flex items-center justify-between">
        <div className="flex items-center gap-16 cursor-pointer" onClick={toLanding}>
          <img src={logo} alt="logo" className="w-[160px]" />
        </div>

        <nav className="flex items-center gap-12 text-[18px] font-medium">
          <Link
            to="/pipeline"
            className="text-brand-dark hover:text-brand-green transition font-semibold"
          >
            Pipeline
          </Link>
        </nav>

        <div className="flex items-center gap-4">
          <AvatarIcon />

        </div>
      </div>
    </header>
  )
}

export default AppNavbar